import React, { useEffect, useState } from 'react';
import { useScrollClass } from './hooks';
import { useStoreModal } from './storeModalContext';

const Nav: React.FC = () => {
  const scrolled = useScrollClass(80);
  const { open: openStore } = useStoreModal();
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = drawerOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [drawerOpen]);

  const storeClick = () => {
    setDrawerOpen(false);
    openStore();
  };

  return (
    <>
      <nav id="nav" className={scrolled ? 'scrolled' : undefined}>
        <div className="nav-inner">
          <a href="/" className="nav-logo" aria-label="Niyyah home">
            <img src="/niyyah-logo-black.png" alt="Niyyah" style={{ height: 30, width: 'auto' }} />
          </a>
          <div className="nav-links">
            <a href="#sheikh">Scholars</a>
            <a href="#topics">Topics</a>
            <a href="#faq">FAQ</a>
          </div>
          <div className="nav-cta">
            <button type="button" className="btn-primary" onClick={storeClick}>
              Start now
            </button>
            <button
              className="nav-burger"
              aria-label="Open menu"
              aria-expanded={drawerOpen}
              onClick={() => setDrawerOpen(true)}
              type="button"
            >
              <span />
            </button>
          </div>
        </div>
      </nav>

      <div
        className={`nav-drawer${drawerOpen ? ' open' : ''}`}
        aria-hidden={!drawerOpen}
      >
        <div className="nav-drawer-top">
          <a href="/" className="nav-logo" aria-label="Niyyah home" onClick={() => setDrawerOpen(false)}>
            <img src="/niyyah-logo-black.png" alt="Niyyah" style={{ height: 28, width: 'auto' }} />
          </a>
          <button
            className="nav-drawer-close"
            aria-label="Close menu"
            onClick={() => setDrawerOpen(false)}
            type="button"
          >
            ×
          </button>
        </div>
        <div className="nav-drawer-links">
          <a href="#sheikh" onClick={() => setDrawerOpen(false)}>Scholars</a>
          <a href="#topics" onClick={() => setDrawerOpen(false)}>Topics</a>
          <a href="#faq" onClick={() => setDrawerOpen(false)}>FAQ</a>
        </div>
        <div className="nav-drawer-bottom">
          <button type="button" className="btn-primary" onClick={storeClick}>
            Start now
          </button>
        </div>
      </div>
    </>
  );
};

export default Nav;
